import { useEffect, useState } from "react";

import { defaultBrandFilters } from "../misc/schema";

/**
 * Draft state for the brands filter drawer — the drawer edits a copy and only
 * commits it to the list on Apply.
 */
const useBrandsFilterDrawer = ({ open, filters, onClose, onApply }) => {
    const [draft, setDraft] = useState(filters);

    // Re-sync the draft to the committed filters whenever the drawer opens,
    // so re-opening after a previous Apply/Clear starts from the real state.
    useEffect(() => {
        if (open) setDraft(filters);
    }, [open, filters]);

    const setField = (name) => (value) => setDraft((prev) => ({ ...prev, [name]: value }));

    const handleApply = () => {
        onApply(draft);
        onClose();
    };

    const handleClear = () => {
        setDraft(defaultBrandFilters);
    };

    return {
        draft,
        setField,
        handleApply,
        handleClear
    };
};

export default useBrandsFilterDrawer;
